// extracted by mini-css-extract-plugin
export default {"column":"MhmFO","divider":"G6V+i"};